export const FULL = 1119;
